import React, { useState, useRef, useEffect, useContext } from 'react';
import { Text, FluentProvider, webLightTheme, webDarkTheme } from '@fluentui/react-components';
import './styles/viewer.css';
import './styles/global.css';
import LoadingScreen from './LoadingScreen';
import StatusBar from './StatusBar';
import blitzSessionContext from '../../../../context/blitzsession/blitzSessionContext';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import ModalMain from '../../../../components/Modal/ModalMain';
import { t } from 'i18next';
import themeContext from '../../../../context/theme/ThemeContext';

const BlitzSession = () => {
  const {
    isDarkTheme, setIsDarkTheme, isLoading, showCloseBlitzPopup, setShowCloseBlitzPopup, showCaseRemovedPopup, handleCloseRemovedCasePopup, iframeOrder, visibleIframe,
    iframeRefs, transitionDirection, isTransitioning, getStudyUrl, handleIframeLoad, showEmptyQueuePopup, logBlitzSessionClose
  } = useContext(blitzSessionContext);

  const { getThemeColor} = useContext(themeContext);

  const handleCloseViewerPopup = () => {
    setShowCloseBlitzPopup(true);
  }

  const handleThemeToggle = () => {
    setIsDarkTheme(!isDarkTheme);
  };

  const handleCloseViewer = async (reason) => {
    logBlitzSessionClose(reason);
    window.close();
  };

  let PrimaryButtonList = [
    {
      title: t("confirm-message.yes"),
      onclick: () => {
        handleCloseViewer("EXPLICIT_CLOSE");
      },
    }
  ];

  let DefaultButtonList = [
    {
      title: t("confirm-message.no"),
      onclick: () => {
        setShowCloseBlitzPopup(false);
      },
    },
  ];

  let PrimaryButtonList2 = [
    {
      title: t("confirm-message.next"),
      onclick: () => {
        handleCloseRemovedCasePopup();
      },
    },
  ];

  let PrimaryButtonList3 = [
    {
      title: t("confirm-message.exit"),
      onclick: () => {
        handleCloseViewer("NO_MORE_CASES");
      },
    }
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        heading={t("confirm-message.alert")}
        //hideCancelIcon={false}
        handleCancel={()=>setShowCloseBlitzPopup(false)}
        updatedModal={true}
      />
    ),
    body: <div className="global-modal-body" style={{color:getThemeColor("primary-color")}}>Do you want to exit Blitz Session?</div>,
    footer: <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList} />,
    width: "600px",
  };

  const modalDetails2 = {
    header: (
      <ModalHeader
        heading={t("confirm-message.alert")}
        hideCancelIcon={true}
        updatedModal={true}
      />
    ),
    body: <RemovedFromQueueModal onProceed={handleCloseRemovedCasePopup} />,
    footer: <ModalFooter PrimaryButtonList={PrimaryButtonList2} />,
    width: "600px",
  };

  const modalDetails3 = {
    header: (
      <ModalHeader
        heading={t("confirm-message.alert")}
        hideCancelIcon={true}
        updatedModal={true}
      />
    ),
    body: <div className="global-modal-body" style={{color:getThemeColor("primary-color")}}>There are no more cases in the queue.</div>,
    footer: <ModalFooter PrimaryButtonList={PrimaryButtonList3} />,
    width: "600px",
  };

  return (
    <FluentProvider theme={isDarkTheme ? webDarkTheme : webLightTheme}>
      <div className={`viewer-container ${isDarkTheme ? 'dark-theme' : 'light-theme'}`}>

        {isLoading && (
          <LoadingScreen />
        )}
        <div className={'main-content-with-statusbar'}>
          <div className="carousel-container">
            <div className={`case-display current-case ${
              isTransitioning 
               ? (transitionDirection === 'right' ? 'slide-in-right' : 'slide-in-left')
                : ''
            }`}>
              
             {iframeRefs.map((ref, i) => {
              const studyId = iframeOrder[i];
              const url = studyId !== -1 ? getStudyUrl(studyId) : null; 
              return (
                <iframe
                  key={i}
                  ref={ref}
                  src={url || ""}
                  onLoad={() => handleIframeLoad(i)}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    visibility: visibleIframe === i ? "visible" : "hidden",
                  }}
                />
              )})}
            </div>
          </div>
        </div>

        <StatusBar
          // onCaseChange={handleCaseChange}
          onClose={handleCloseViewerPopup}
          onThemeToggle={handleThemeToggle}
        />

        {showCloseBlitzPopup && 
          <ModalMain
            updatedModal={true}
            modalDetails={modalDetails}
            showModal={true}
          />
        }

        {!showEmptyQueuePopup && showCaseRemovedPopup && 
          <ModalMain
            updatedModal={true}
            modalDetails={modalDetails2}
            showModal={true}
          />
        }

        {showEmptyQueuePopup && 
          <ModalMain
            updatedModal={true}
            modalDetails={modalDetails3}
            showModal={true}
          />
        }
      </div>
    </FluentProvider>
  );
};

export default BlitzSession;

export const RemovedFromQueueModal = ({ onProceed }) => {
  const [seconds, setSeconds] = useState(10);
  const { getThemeColor} = useContext(themeContext);

  useEffect(() => {
    if (seconds === 0) {
      onProceed();
      return;
    }

    const interval = setInterval(() => {
      setSeconds((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, onProceed]);

  return (
    <div className="global-modal-body" style={{color:getThemeColor("primary-color")}}>This study is no longer assigned to you. You will be automatically moved to the next case in {seconds} seconds.
    </div>
  );
};